














































































































































import {
  defineComponent,
  ref,
  computed,
  PropType,
  toRefs,
  useRouter
} from '@nuxtjs/composition-api'
import { ciFilterCategoriesV2 } from '~/icons/source/regular/filter-categories-v2'
import { ciHistory } from '~/icons/source/regular/history'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import ClassifiedSearchFacetsComponentsService from '~/services/search/ClassifiedSearchFacetsComponentsService'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import Facets from '~/components/car/classifieds/search/facets/Facets.vue'
import { useDep } from '~/compositions/dependency-container'
import SearchService from '~/services/search/SearchService'
import BuyLeasingHandler from '../classifieds/search/facets/handlers/BuyLeasingHandler.vue'
import ClearAllHandler from '../classifieds/search/facets/handlers/ClearAllHandler.vue'
import Searchbar from '~/components/shared/classified/search/searchbar/Searchbar.vue'
import useQuickSearchMenu from '~/compositions/quick-search-menu/quick-search-menu'
import { Facet } from '~/models/search/types'
import ForMakeModelSearchHandler from '../classifieds/search/facets/handlers/MakeModel/ForMakeModelSearchHandler.vue'
import { formatNumber } from '~/utils/number'
import { capitalizeSentences } from '~/utils/string'
import {
  RESET_ROW_RESULTS,
  SET_LOADING_FACETS
} from '~/store/modules/shared/classifieds/search/mutation-types'
import { useI18n } from '~/compositions/i18n'
import { CategoryId } from '~/models/category/types'

export default defineComponent({
  components: {
    CCustomSelect,
    Facets,
    ClearAllHandler,
    Searchbar,
    ForMakeModelSearchHandler
  },
  props: {
    facets: {
      type: Array as PropType<Facet[]>,
      default: () => []
    },
    isFullWidth: {
      type: Boolean,
      default: true
    },
    topLevelId: {
      type: String,
      default: ''
    },
    subCategoryId: {
      type: String,
      default: ''
    },
    thirdLevelCategoryId: {
      type: String,
      default: ''
    },
    hasSearchbar: {
      type: Boolean,
      default: false
    },
    isRentalsQuickSearch: {
      type: Boolean,
      default: false
    },
    isProfessionalQuickSearch: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { subCategoryId, thirdLevelCategoryId, topLevelId } = toRefs(props)

    const classifiedSearchFacetsComponentsService = useDep(
      ClassifiedSearchFacetsComponentsService
    )
    const searchService = useDep(SearchService)
    const { state, getters, commit } = useNamespacedStore<SearchState>(
      CLASSIFIED_SEARCH_NS
    )
    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )
    const router = useRouter()
    const { tc } = useI18n()

    const parentID = topLevelId

    const hideClearBtn = ref(false)

    const isPc = computed(() => userAgentGetters('isPc'))
    const getSeoUrl = computed(() => getters('getSeoUrl'))
    const getTargetSeoUrl = computed(() => getters('getTargetSeoUrl'))
    const getExternalUrl = computed(() => getters('getLegacyAllFiltersPage'))
    const totalRows = computed(() => state.stats?.total)
    const loadingFacets = computed(() => state.loading.facets)

    const icons = {
      filters: ciFilterCategoriesV2,
      history: ciHistory
    }

    const updateUrlToMirrorFacets = () => {
      if (
        process.client &&
        getSeoUrl.value !== window.location.pathname + window.location.search
      ) {
        const url = new URL(window.location.origin + getSeoUrl.value)
        const seoParams = url.search
        window.history.replaceState(
          { isInSearchPage: true, isQuickSearch: true },
          '',
          window.location.origin + window.location.pathname + seoParams
        )
      }
    }

    const handleShowClassifiedsButtonClick = () => {
      emit('hide-clear-btn', true)
      hideClearBtn.value = true

      updateUrlToMirrorFacets()

      commit(RESET_ROW_RESULTS)
      commit(SET_LOADING_FACETS, true)

      router.push({ path: getTargetSeoUrl.value })
    }

    const {
      handleGridColumsPerFacet,
      handleComponentBindings
    } = useQuickSearchMenu(parentID, subCategoryId, thirdLevelCategoryId)

    const component = (type: string) => {
      if (type === 'FinanceSearchHandler') {
        return BuyLeasingHandler
      }
      return classifiedSearchFacetsComponentsService.getFacetComponent(type)
    }

    const showClassifiedsButtonIsLoading = computed(() => {
      return loadingFacets.value
    })

    const resultsText = computed(() => {
      return capitalizeSentences(
        tc(
          'show 1 classified | show {count} classifieds',
          formatNumber(totalRows.value!) as any
        )
      )
    })

    const searchbarCategoryId = computed(() => {
      if (subCategoryId.value) {
        return Number(subCategoryId.value) as CategoryId
      }

      if (topLevelId.value) {
        return Number(topLevelId.value) as CategoryId
      }

      return undefined
    })

    return {
      searchbarCategoryId,
      icons,
      component,
      searchService,
      loadingFacets,
      handleGridColumsPerFacet,
      handleComponentBindings,
      handleShowClassifiedsButtonClick,
      isPc,
      getSeoUrl,
      getExternalUrl,
      hideClearBtn,
      showClassifiedsButtonIsLoading,
      resultsText
    }
  }
})
